import React from 'react'
import EdicionCaratulaInactiva from '../containers/EdicionCaratulaInactiva'
import EdicionCaratulaActiva from '../containers/EdicionCaratulaActiva'
import EdicionCaratulaFinalizada from '../containers/EdicionCaratulaFinalizada'
import EdicionCoem from '../containers/EdicionCoem'

export const COEM = 'COEM'
export const CARATULA = 'CARATULA'
export const ALTA_COEM = 'ALTA COEM'
export const REGISTRAR_COEM = 'REGISTRAR COEM'
export const REGISTRAR_CARATULA = 'REGISTRAR CARATULA'
export const RECTIFICAR_COEM = 'RECTIFICAR COEM'
export const RECTIFICAR_CARATULA = 'RECTIFICAR CARATULA'
export const ANULAR_COEM = 'ANULAR COEM'
export const ELIMINAR_COEM = 'ELIMINAR COEM'
export const ANULAR_CARATULA = 'ANULAR CARATULA'
export const CERRAR_COEM = 'CERRAR COEM'
export const SOLICITAR_CAMBIO_BUQUE = 'SOLICITAR CAMBIO BUQUE'
export const SOLICITAR_CAMBIO_FECHAS = 'SOLICITAR CAMBIO FECHAS'
export const SOLICITAR_ANULACION_COEM = 'SOLICITAR ANULACION COEM'
export const SOLICITAR_NO_A_BORDO = 'SOLICITAR NO A BORDO'
export const SOLICITAR_CIERRE_CARGA_GRANEL = 'SOLICITAR CIERRE CARGA GRANEL'
export const SOLICITAR_CAMBIO_LOT = 'SOLICITAR CAMBIO LUGAR OPERATIVO'

export const COLUMNS_HISTORIAL = [
  {
    name: 'fecha',
    label: 'Fecha',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'identificadorAduana',
    label: 'Identificador Aduana',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'descripcion',
    label: 'Descripcion',
    options: {
      filter: true,
      sort: true
    }
  }
]

export const COLUMNS_LISTADO_COMUNICACIONES_ACTIVAS = [
  {
    name: 'id',
    label: '#',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'nombreBuque',
    label: 'Buque',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'aceitero',
    label: 'Aceitero',
    options: {
      filter: true,
      sort: true,
      display: false
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      display: false
    }
  },
  {
    name: 'aceitero',
    label: 'Producto',
    options: {
      print: false,
      filter: false,
      sort: false,
      customBodyRender: (value, tableMeta) => {
        const producto = (value === true ? 'ACEITE' : tableMeta.rowData[3])
        return <>{producto}</>
      }
    }
  },
  {
    name: 'agenciaMaritimaRazonSocial',
    label: 'Ag. Marítima',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'fechaDeArribo',
    label: 'Fecha Arribo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'fechaDeZarpada',
    label: 'Fecha Zarpada',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'nombreGiro',
    label: 'Muelle',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'identificadorCaratula',
    label: 'Carátula',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'observaciones',
    label: 'Últ. Acción',
    options: {
      filter: false,
      sort: false
    }
  },
  {
    name: 'id',
    label: 'Acciones',
    options: {
      print: false,
      filter: false,
      sort: false,
      customBodyRender: value => {
        return <EdicionCaratulaActiva id={value} />
      }
    }
  }
]

export const COLUMNS_LISTADO_COMUNICACIONES_INACTIVAS = [
  {
    name: 'id',
    label: '#',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'nombreBuque',
    label: 'Buque',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'aceitero',
    label: 'Aceitero',
    options: {
      filter: true,
      sort: true,
      display: false
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      display: false
    }
  },
  {
    name: 'aceitero',
    label: 'Producto',
    options: {
      print: false,
      filter: false,
      sort: false,
      customBodyRender: (value, tableMeta) => {
        const producto = (value === true ? 'ACEITE' : tableMeta.rowData[3])
        return <>{producto}</>
      }
    }
  },
  {
    name: 'agenciaMaritimaRazonSocial',
    label: 'Ag. Marítima',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'fechaDeArribo',
    label: 'Fecha Arribo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'fechaDeZarpada',
    label: 'Fecha Zarpada',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'nombreGiro',
    label: 'Muelle',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'observaciones',
    label: 'Últ. Acción',
    options: {
      filter: false,
      sort: false
    }
  },
  {
    name: 'id',
    label: 'Acciones',
    options: {
      print: false,
      filter: false,
      sort: false,
      customBodyRender: value => {
        return <EdicionCaratulaInactiva id={value} />
      }
    }
  }
]

export const COLUMNS_LISTADO_COMUNICACIONES_FINALIZADAS = [
  {
    name: 'id',
    label: '#',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'nombreBuque',
    label: 'Buque',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'aceitero',
    label: 'Aceitero',
    options: {
      filter: true,
      sort: true,
      display: false
    }
  },
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true,
      display: false
    }
  },
  {
    name: 'aceitero',
    label: 'Producto',
    options: {
      print: false,
      filter: false,
      sort: false,
      customBodyRender: (value, tableMeta) => {
        const producto = (value === true ? 'ACEITE' : tableMeta.rowData[3])
        return <>{producto}</>
      }
    }
  },
  {
    name: 'agenciaMaritimaRazonSocial',
    label: 'Ag. Marítima',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'fechaDeArribo',
    label: 'Fecha Arribo',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'fechaDeZarpada',
    label: 'Fecha Zarpada',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'pesoFinal',
    label: 'Peso Embarcado',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'nombreGiro',
    label: 'Muelle',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'identificadorCaratula',
    label: 'Carátula',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'identificadorCode',
    label: 'CODE',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'observaciones',
    label: 'Últ. Acción',
    options: {
      filter: false,
      sort: true
    }
  },
  {
    name: 'id',
    label: 'Acciones',
    options: {
      print: false,
      filter: false,
      sort: false,
      customBodyRender: value => {
        return <EdicionCaratulaFinalizada id={value} />
      }
    }
  }
]

export const COLUMNS_LISTADO_COMUNICACIONES_TO_PRINT = [
  {
    name: 'nombre',
    label: 'Nombre',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'nombreCorto',
    label: 'Nombre Corto',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'bandera',
    label: 'Bandera',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'eslora',
    label: 'Eslora',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'manga',
    label: 'Manga',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'pesoBruto',
    label: 'Peso Bruto',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'pesoDeDesplazamiento',
    label: 'Peso Desplazamiento',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'mmsi',
    label: '# MMSI',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'imo',
    label: '# IMO',
    width: 50,
    mantenerCase: true
  }
]

export const COLUMNS_LISTADO_COEMS = [
  {
    name: 'id',
    label: '#',
    options: {
      filter: false,
      sort: true
    }
  },
  // {
  //   name: 'item',
  //   label: 'Item',
  //   options: {
  //     filter: true,
  //     sort: true
  //   }
  // },
  {
    name: 'identificadorAduana',
    label: 'Identificador Aduana',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'identificadorDeclaracion',
    label: 'Permiso de Embarque',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'exportadorRazonSocial',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'peso',
    label: 'Peso Registrado',
    options: {
      filter: true,
      sort: true,
      total: true,
      totalFloat: 'right',
      setCellProps: () => ({
        style: {
          textAlign: 'right',
          fontWeight: 'bold'
        }
      })
    }
  },
  {
    name: 'cerrada',
    label: 'Estado',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => value
        ? <><strong style={{ color: '#023a1ade' }}>Cerrada</strong> </>
        : <><strong style={{ color: '#8e1a05de' }}>Abierta</strong> </>
    }
  },
  {
    name: 'observaciones',
    label: 'Últ. Acción',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'id',
    label: 'Acciones',
    options: {
      print: false,
      filter: false,
      sort: false,
      customBodyRender: value => {
        return <EdicionCoem id={value} />
      }
    }
  }
]

export const COLUMNS_LISTADO_COEMS_CERRADOS = [
  // {
  //   name: 'identificadorAduana',
  //   label: 'Identificador Aduana',
  //   options: {
  //     filter: true,
  //     sort: true
  //   }
  // },
  {
    name: 'identificadorDeclaracion',
    label: 'Permiso de Emb.',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'exportadorRazonSocial',
    label: 'Exportador',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'peso',
    label: 'Peso Registrado',
    options: {
      filter: true,
      sort: true,
      total: true,
      totalFloat: 'right',
      setCellProps: () => ({
        style: {
          textAlign: 'right',
          fontWeight: 'bold'
        }
      })
    }
  },
  {
    name: 'fechaDeEmbarque',
    label: 'Finalización Embarque',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'pesoEmbarcado',
    label: 'P. Item 1',
    options: {
      filter: true,
      sort: true,
      total: true,
      totalFloat: 'right',
      setCellProps: () => ({
        style: {
          textAlign: 'right',
          fontWeight: 'bold'
        }
      })
    }
  },
  {
    name: 'pesoEmbarcadoItem2',
    label: 'P. Item 2',
    options: {
      filter: true,
      sort: true,
      total: true,
      totalFloat: 'right',
      setCellProps: () => ({
        style: {
          textAlign: 'right',
          fontWeight: 'bold'
        }
      })
    }
  },
  {
    name: 'pesoEmbarcadoItem3',
    label: 'P. Item 3',
    options: {
      filter: true,
      sort: true,
      total: true,
      totalFloat: 'right',
      setCellProps: () => ({
        style: {
          textAlign: 'right',
          fontWeight: 'bold'
        }
      })
    }
  },
  {
    name: 'pesoEmbarcadoItem4',
    label: 'P. Item 4',
    options: {
      filter: true,
      sort: true,
      total: true,
      totalFloat: 'right',
      setCellProps: () => ({
        style: {
          textAlign: 'right',
          fontWeight: 'bold'
        }
      })
    }
  },
  {
    name: 'cierreCumplido',
    label: 'Cumplido',
    options: {
      filter: true,
      sort: true,
      customBodyRender: (value) => value
        ? <><strong style={{ color: '#023a1ade' }}>Si</strong> </>
        : <><strong style={{ color: '#8e1a05de' }}>No</strong> </>
    }
  },
  {
    name: 'observaciones',
    label: 'Últ. Acción',
    options: {
      filter: true,
      sort: true
    }
  }
]

export const COLUMNS_LISTADO_COEMS_TO_PRINT = []

export const COLUMNS_LISTADO_EXPORTADORES_POR_CARATULA = [
  {
    name: 'razonSocial',
    label: ' ',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'exportador',
    label: ' ',
    options: {
      filter: true,
      sort: true
    }
  }
]

export const COLUMNS_LISTADO_EXPORTADORES_POR_CARATULA_TO_PRINT = []